import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function RelatedListings({ yachtType, title }) {
  const [yachts, setYachts] = useState([]);

  useEffect(() => {
    fetchRelatedYachts();
  }, [yachtType]);

  const fetchRelatedYachts = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/yachts?yacht_type=${yachtType}`);
      setYachts(response.data.slice(0, 3));
    } catch (error) {
      console.error('Error fetching related yachts:', error);
    }
  };

  if (yachts.length === 0) return null;

  return (
    <div className="mt-12 glass-light p-8">
      <h3 className="text-2xl font-medium mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
        {title || `View ${yachtType.charAt(0).toUpperCase() + yachtType.slice(1)} Yachts for Sale/Charter`}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        {yachts.map((yacht) => (
          <Link
            key={yacht.yacht_id}
            to={`/yacht/${yacht.yacht_id}`}
            className="group"
            data-testid={`related-yacht-${yacht.yacht_id}`}
          >
            <div className="aspect-[4/3] overflow-hidden mb-3">
              <img
                src={yacht.images[0]}
                alt={yacht.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            <h4 className="font-medium text-white group-hover:text-gold transition-colors">{yacht.name}</h4>
            <p className="text-sm text-white/60">{yacht.location}</p>
            <p className="text-gold font-semibold mt-2">
              {yacht.charter_weekly_usd
                ? `$${yacht.charter_weekly_usd.toLocaleString()}/week`
                : `$${yacht.price_usd?.toLocaleString()}`}
            </p>
          </Link>
        ))}
      </div>
      <Link to="/listings">
        <Button variant="outline" className="border-gold text-gold hover:bg-gold hover:text-[#0A192F]">
          View All Listings <ArrowRight size={16} className="ml-2" />
        </Button>
      </Link>
    </div>
  );
}
